/* eslint-disable react/no-unescaped-entities */
import React from 'react'

import { Accordion, Box, BoxProps, Link } from '@clear/design-system'

function FinePrint(props: BoxProps) {
  return (
    <Box {...props}>
      <Accordion
        title="Privacy Act Statement"
        previewContent
        containerProps={{ mb: 5 }}
      >
        Authority: 6 U.S.C. § 1140, 46 U.S.C. § 70105; 49 U.S.C. §§ 106, 114,
        5103a, 40103(b)(3), 40113, 44903, 44935-44936, 44939, and 46105; the
        Implementing Recommendations of the 9/11 Commission Act of 2007, § 1520
        (121 Stat. 444, Public Law 110-52, August 3, 2007); and Executive Order
        9397, as amended.
        <br />
        <br />
        Purpose: The Department of Homeland Security (DHS) will use your
        information to conduct a security threat assessment. Your fingerprints
        and associated information will be provided to the Federal Bureau of
        Investigation (FBI) for the purpose of comparing your fingerprints to
        other fingerprints in the FBI's Next Generation Identification (NGI)
        system or its successor systems including civil, criminal, and latent
        fingerprint repositories. The FBI may retain your fingerprints and
        associated information in NGI after the completion of this application
        and, while retained, your fingerprints may continue to be compared
        against other fingerprints submitted to or retained by NGI. DHS will
        also transmit your fingerprints for enrollment into DHS OBIM Automated
        Biometrics Identification System (IDENT). Biometrics collected from
        applicants to the TSA&nbsp;PreCheck® Application Program may also be
        used to conduct screening at airport checkpoints. If you provide your
        Social Security Number (SSN), DHS may provide your name and SSN to the
        Social Security Administration (SSA) to compare that information against
        SSA records to ensure the validity of the information.
        <br />
        <br />
        Routine Uses: This system may disclose information in accordance with
        the Privacy Act, 5 U.S.C. 552a(b), including as a routine use pursuant
        to 5 U.S.C. 552a(b)(3) with third parties during the course of a
        security threat assessment, employment investigation, or adjudication of
        a waiver or appeal request to the extent necessary to obtain information
        pertinent to the assessment, investigation, or adjudication of your
        application under the TSA system of records notice (SORN) DHS/TSA 002,
        Transportation Security Threat Assessment System, or DHS/TSA 021,
        TSA&nbsp;PreCheck® Application Program for applicants to that program.
        Disqualifying criminal offenses uncovered during your application limit
        your ability to access TSA&nbsp;PreCheck® expedited screening. For as
        long as your fingerprints and associated information are retained in
        NGI, your information may be disclosed pursuant to your consent or
        without your consent as permitted by the Privacy Act of 1974 and all
        applicable Routine Uses as may be published at any time in the Federal
        Register, including the Routine Uses for the NGI system and the FBI's
        Blanket Routine Uses.
        <br />
        <br />
        Disclosure: Furnishing this information (including your SSN) is
        voluntary; however, if you do not provide your SSN or any other
        information requested, DHS may be unable to complete your application
        for a security threat assessment.
      </Accordion>
      <Accordion title="Paperwork Reduction Act Statement" previewContent>
        Statement of Public Burden: This is a voluntary collection of
        information, but failure to provide the information may result in an
        inability to approve your eligibility for the requested TSA program or
        benefit. TSA estimates that the total average burden per response
        associated with this collection for enrollment is approximately 30
        minutes. An agency may not conduct or sponsor, and a person is not
        required to respond to, a collection of information unless it displays a
        valid OMB control number. The control number for this collection is OMB
        1652-0059, which expires 03/31/2028.
      </Accordion>
      <Accordion
        title="FBI Privacy Act Statement and Additional Information"
        previewContent
      >
        Customers can obtain the FBI Privacy Act Statement and information on
        how to challenge accuracy of background reports and/or report a PII
        breach to the FBI by visiting the{' '}
        <Link
          variant="display"
          color="brandDarkBlue"
          target="_blank"
          href="/help#fbi"
        >
          "FBI Information" section in the FAQ
        </Link>
        .
      </Accordion>
    </Box>
  )
}

export default FinePrint
